var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLightDarkModeMobile = function SvgLightDarkModeMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 54302",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108492",
    d: "M23 0A23 23 0 1 1 0 23 23 23 0 0 1 23 0Z",
    fill: "rgba(32,36,39,0.05)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#202427"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108466",
    d: "M22.37 14.183h1.26v3.149h-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108467",
    d: "M22.37 28.667h1.26v3.149h-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108468",
    d: "M28.667 22.37h3.149v1.26h-3.149Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108469",
    d: "M14.183 22.37h3.149v1.26h-3.149Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108470",
    d: "m26.561 18.53 2.226-2.226.891.891-2.226 2.226Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108471",
    d: "m16.32 28.804 2.226-2.226.891.891-2.226 2.227Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108472",
    d: "m26.578 27.454.891-.891 2.227 2.226-.891.891Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108473",
    d: "m16.303 17.211.891-.891 2.229 2.231-.891.891Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108474",
    d: "M22.999 18.591a4.408 4.408 0 1 0 4.408 4.408 4.421 4.421 0 0 0-4.408-4.408Zm0 7.557a3.149 3.149 0 1 1 3.149-3.149 3.158 3.158 0 0 1-3.149 3.149Z"
  }))));
};
export default SvgLightDarkModeMobile;